import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';

const Access = ({ access, isModal, loading, title }) => {
  if (loading || !access) {
    return;
  }

  // Box shadow on in SiteSheetPage, off in ShiftModal
  const variant = isModal ? 'outlined' : null;

  return (
    <Card id="access-card" variant={variant}>
      <CardHeader title={title} />
      <CardContent>
        <Typography id="access-content" component="pre">
          {access}
        </Typography>
      </CardContent>
    </Card>
  );
};
Access.propTypes = {
  access: PropTypes.string,
  isModal: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.string
};

export default Access;
